import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {OrganizationPermissionRole} from 'orgs/OrganizationConstants';

import GroupsSection, {GroupRowInfo} from './CreateUsersGroupSection';
import {CreateUsersModalOrganization} from './CreateUsersModal';

export const EMPTY_ORGANIZATION_INFO: GroupRowInfo<CreateUsersModalOrganization> = {
  group: null,
  role: OrganizationPermissionRole.MEMBER,
};

const ORGANIZATION_MEMBER_ROLE_TO_TEXT = {
  [OrganizationPermissionRole.ADMIN]: 'Admin',
  [OrganizationPermissionRole.MEMBER]: 'Member',
};

interface OrganizationSectionProps {
  disabled: boolean;
  onUpdate: (organizationRowInfos: Array<GroupRowInfo<CreateUsersModalOrganization>>) => void;
  organizations: Array<CreateUsersModalOrganization>;
  organizationRowInfos: Array<GroupRowInfo<CreateUsersModalOrganization>>;
}

export default function OrganizationsSection(props: OrganizationSectionProps): JSX.Element {
  return (
    <GroupsSection
      disabled={props.disabled}
      groups={props.organizations}
      groupRowInfos={props.organizationRowInfos}
      onUpdate={props.onUpdate}
      emptyRowInfo={EMPTY_ORGANIZATION_INFO}
      roleToText={ORGANIZATION_MEMBER_ROLE_TO_TEXT}
      groupType={ModelTypeConstants.ORGANIZATION}
    />
  );
}
